import appVersion from "./version.json";

export const isDev = process.env.dev;
console.log(`isDev: ${isDev} ${process.env.NODE_ENV}`);

export const apiBaseUrl = isDev
    ? "https://localhost:7164/api/outlook"
    : "https://ttw-email-api.azurewebsites.net/api/outlook";

export const appVersionString = isDev
    ? `${appVersion.major}.${appVersion.minor}.${appVersion.revision}.${appVersion.build}-dev`
    : `${appVersion.major}.${appVersion.minor}.${appVersion.revision}.${appVersion.build}`;

export const AzureClientId = 'b2f2ceec-4de5-4788-8d71-a22490926ec6';

export const AzureAuthorityUrl = 'https://login.microsoftonline.com/4e61e794-0ccf-4725-80e9-8bbf56f17e3c';

export const DevAccessScope = 'api://localhost:3000/cdd317cf-41a2-4f00-af69-77e4aa7219d2/access_as_user';

export const AccessScope = 'api://outlookplugin.ttw.com.au/b4c689d2-dc87-46cd-a2bc-bb67115d6da3/access_as_user';